<template>
  <tree-table class="subheading" style="border-radius: 4px" :data="data" :columns="columns" :border="props.border"
    :is-fold="props.isFold" :tree-type="props.treeType" :show-header="props.showHeader" :expand-type="props.expandType"
    :selection-type="props.selectionType">
    <template slot="customers" scope="scope">
      <p class="subheading">
        {{ scope.row.last_resolution.customers | numeral("0.[00] a") }}
      </p>
      <v-progress-linear style="border-radius: 25px" class="ma-0"
        :value="percentage(scope.row.last_resolution.customers)"></v-progress-linear>
    </template>
    <template slot="stimulus" scope="scope">
      <div style="display: flex" v-if="scope.row && scope.row.stimulus && scope.row.stimulus.length">
        <v-dialog width="1000px" v-if="
          scope.row &&
          scope.row.stimulus &&
          scope.row.stimulus.length &&
          getStimulus(scope.row.stimulus, true).length
        ">
          <template v-slot:activator="{ on }">
            <v-chip @click="getNodeInfo(scope.row.id)" small color="red" class="ma-0 mr-1" text-color="white" v-on="on">
              <v-avatar class="red darken-4">
                <b>{{ getStimulus(scope.row.stimulus, true).length }}</b>
              </v-avatar>
              <b>Localizados</b>
            </v-chip>
          </template>

          <v-card>
            <v-card-title class="headline pb-0" primary-title>
              <v-breadcrumbs :items="breadcrumbs" class="pa-0 ma-0">
                <template v-slot:divider>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
                <template v-slot:item="{ item }">
                  <v-breadcrumbs-item class="subheading black--text" :href="null">
                    {{ item.text.toUpperCase() }}
                  </v-breadcrumbs-item>
                </template>
              </v-breadcrumbs>
              <p class="subheading black--text" small>&nbsp;- LOCALIZADOS</p>
            </v-card-title>

            <v-card-text class="pa-0">
              <v-list dense subheader three-line >
                <template v-for="(item, index) in getStimulus(scope.row.stimulus, true)">
                  <a @click="goToTreeApproaches(item)" v-if="item.approach_flow.name && item.active_at !== null">
                    <v-subheader class="indigo--text" :key="item.approach_flow.name">
                      {{ item.order }}º - #{{ item.approach_flow.id }} - {{ item.approach_flow.name }}
                      <v-chip small v-if="item.approach_flow.campaign">{{ item.approach_flow.campaign }}</v-chip>
                    </v-subheader>
                      <v-list-tile :key="item.id" class="qj-offset-list">
                        <v-list-tile-content>
                          <v-list-tile-sub-title class="text--primary">
                            <v-layout row wrap style="overflow-y: auto;">
                            <v-tooltip bottom v-for="(approachRule, index) in getApproachRules(item)" :key="index">
                              <template v-slot:activator="{ on }">
                                <v-chip small :color="getColorApproachRule(approachRule.type)" text-color="white"
                                  v-on="on">
                                  <b>{{ approachRule.offset }}</b>
                                </v-chip>
                              </template>
                              <span>{{ approachRule.type }}: {{ approachRule.time }}</span>
                              <v-spacer />
                              <span>{{ approachRule.stimulus.text }}</span>
                              <span>{{ approachRule.stimulus.subject }}</span>
                              <span>{{ approachRule.stimulus.body }}</span>
                            </v-tooltip>
                            </v-layout>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                  </a>
                  <a @click="goToTreeApproaches(item)" v-if="item.approach_flow.name && item.active_at == null" style="opacity:.3">
                    <v-subheader class="grey--text" :key="item.approach_flow.name">
                      {{ item.order }}º - #{{ item.approach_flow.id }} - {{ item.approach_flow.name }}
                      <v-chip small v-if="item.approach_flow.campaign">{{ item.approach_flow.campaign }}</v-chip>
                    </v-subheader>
                    
                      <v-list-tile :key="item.id" class="qj-offset-list">
                        <v-list-tile-content>
                          <v-list-tile-sub-title class="text--primary">
                            <v-layout row wrap style="overflow-y: auto;">
                            <v-tooltip bottom v-for="(approachRule, index) in getApproachRules(item)" :key="index">
                              <template v-slot:activator="{ on }">
                                <v-chip small :color="getColorApproachRule(approachRule.type)" text-color="white"
                                  v-on="on">
                                  <b>{{ approachRule.offset }}</b>
                                </v-chip>
                              </template>
                              <span>{{ approachRule.type }}: {{ approachRule.time }}</span>
                              <v-spacer />
                              <span>{{ approachRule.stimulus.text }}</span>
                            </v-tooltip>
                            </v-layout>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    
                  </a>
                </template>
              </v-list>
              <div class="text-xs-right pb-2">
                <span class="tag-approach-type small SMS">SMS</span>
                <span class="tag-approach-type small EMAIL">EMAIL</span>
                <span class="tag-approach-type small PUSH">PUSH</span>
                <span class="tag-approach-type small CALL_CELLPHONE">CALL CELPHONE</span>
                <span class="tag-approach-type small CALL_PHONE">CALL PHONE</span>
                <span class="tag-approach-type small WHATSAPP">WHATSAPP</span>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog width="1000px" v-if="
          scope.row &&
          scope.row.stimulus &&
          scope.row.stimulus.length &&
          getStimulus(scope.row.stimulus).length
        ">
          <template v-slot:activator="{ on }">
            <v-chip @click="getNodeInfo(scope.row.id)" small disabled class="ma-0" color="orange" text-color="white"
              v-on="on">
              <v-avatar class="orange darken-4">
                <b>{{ getStimulus(scope.row.stimulus).length }}</b>
              </v-avatar>
              <b>Não localizados</b>
            </v-chip>
          </template>

          <v-card>
            <v-card-title class="headline pb-0" primary-title>
              <v-breadcrumbs :items="breadcrumbs" class="pa-0 ma-0">
                <template v-slot:divider>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
                <template v-slot:item="{ item }">
                  <v-breadcrumbs-item class="subheading black--text" :href="null">
                    {{ item.text.toUpperCase() }}
                  </v-breadcrumbs-item>
                </template>
              </v-breadcrumbs>
              <p class="subheading black--text" small>&nbsp;- NÃO LOCALIZADOS</p>
            </v-card-title>

            <v-card-text class="pa-0">
              <v-list dense subheader three-line >
                <template v-for="(item, index) in getStimulus(scope.row.stimulus, false)">
                  <a @click="goToTreeApproaches(item)" v-if="item.approach_flow.name && item.active_at !== null">
                    <v-subheader class="indigo--text" :key="item.approach_flow.name">
                      {{ item.order }}º - #{{ item.approach_flow.id }} - {{ item.approach_flow.name }}
                      <v-chip small v-if="item.approach_flow.campaign">{{ item.approach_flow.campaign }}</v-chip>
                    </v-subheader>
                      <v-list-tile :key="item.id" class="qj-offset-list">
                        <v-list-tile-content>
                          <v-list-tile-sub-title class="text--primary">
                            <v-layout row wrap style="overflow-y: auto;">
                            <v-tooltip bottom v-for="(approachRule, index) in getApproachRules(item)" :key="index">
                              <template v-slot:activator="{ on }">
                                <v-chip small :color="getColorApproachRule(approachRule.type)" text-color="white"
                                  v-on="on">
                                  <b>{{ approachRule.offset }}</b>
                                </v-chip>
                              </template>
                              <span>{{ approachRule.type }}: {{ approachRule.time }}</span>
                              <v-spacer />
                              <span>{{ approachRule.stimulus.text }}</span>
                            </v-tooltip>
                            </v-layout>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                  </a>
                  <a @click="goToTreeApproaches(item)" v-if="item.approach_flow.name && item.active_at == null" style="opacity:.3">
                    <v-subheader class="grey--text" :key="item.approach_flow.name">
                      {{ item.order }}º - #{{ item.approach_flow.id }} - {{ item.approach_flow.name }}
                      <v-chip small v-if="item.approach_flow.campaign">{{ item.approach_flow.campaign }}</v-chip>
                    </v-subheader>
                      <v-list-tile :key="item.id" class="qj-offset-list">
                        <v-list-tile-content>
                          <v-list-tile-sub-title class="text--primary">
                            <v-layout row wrap style="overflow-y: auto;">
                            <v-tooltip bottom v-for="(approachRule, index) in getApproachRules(item)" :key="index">
                              <template v-slot:activator="{ on }">
                                <v-chip small :color="getColorApproachRule(approachRule.type)" text-color="white"
                                  v-on="on">
                                  <b>{{ approachRule.offset }}</b>
                                </v-chip>
                              </template>
                              <span>{{ approachRule.type }}: {{ approachRule.time }}</span>
                              <v-spacer />
                              <span>{{ approachRule.stimulus.text }}</span>
                            </v-tooltip>
                            </v-layout>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                  </a>
                </template>
              </v-list>
              <div class="text-xs-right pb-2">
                <span class="tag-approach-type small SMS">SMS</span>
                <span class="tag-approach-type small EMAIL">EMAIL</span>
                <span class="tag-approach-type small PUSH">PUSH</span>
                <span class="tag-approach-type small CALL_CELLPHONE">CALL CELPHONE</span>
                <span class="tag-approach-type small CALL_PHONE">CALL PHONE</span>
                <span class="tag-approach-type small WHATSAPP">WHATSAPP</span>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template slot="action" scope="scope">
      <div style="display: flex" class="qj-show-hover">
        <v-spacer />
        <!-- Btn modal DialogNodeAnalysis -->
        <v-btn small outline depressed color="primary" class="my-auto ml-0 mr-2 qj-btn-hide"
          :block="$vuetify.breakpoint.xs" @click="info(scope.row)">
          Análise
        </v-btn>
        <!-- Menu -->
        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn icon class="ma-0" v-on="on">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- Novo nó -->
            <v-list-tile @click="add(scope.row)">
              <v-list-tile-title>Adicionar</v-list-tile-title>
            </v-list-tile>
            <!-- Editar nó -->
            <v-list-tile @click="edit(scope.row)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>

            <v-list-group @click.stop>
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>Novo estímulo</v-list-tile-title>
                </v-list-tile>
              </template>
              <!-- Novo estímulo localizado -->
              <v-list-tile @click="newStimulus(scope.row.id)">
                <v-list-tile-title>Localizado</v-list-tile-title>
              </v-list-tile>
              <!-- Novo estímulo não localizado -->
              <v-list-tile @click="newStimulus(scope.row.id, false)">
                <v-list-tile-title>Não Localizado</v-list-tile-title>
              </v-list-tile>
            </v-list-group>

            <v-divider />
            <!-- Mudar status -->
            <v-list-tile @click="update()" v-if="scope.row.id == idRootNode && treeStatus != 'ARCHIVED'">
              <v-list-tile-title>{{
                  treeStatus == "STIMULATE" ? "Desativar estimulos" : "Ativar estimulos"
              }}</v-list-tile-title>
            </v-list-tile>
            <!-- Arquivar nó -->
            <v-list-tile @click="
              scope.row.id != idRootNode ? exclude(scope.row) : disable(scope.row)
            ">
              <v-list-tile-title>{{
                  scope.row.id != idRootNode
                    ? "Excluir"
                    : treeStatus == "ARCHIVED"
                      ? "Desarquivar"
                      : "Arquivar"
              }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </template>
  </tree-table>
</template>

<script>
import TreeTable from "vue-table-with-tree-grid";
import treeService from "@/services/consolidation-tree/consolidation-tree";
import utils from "../utils/util";

export default {
  props: ["data", "treeStatus", "treeActiveAt"],
  components: {
    TreeTable,
  },
  data: function () {
    return {
      props: {
        border: true,
        isFold: false,
        treeType: true,
        showHeader: true,
        expandType: false,
        selectionType: false,
      },
      columns: [
        {
          label: "Nó",
          prop: "name",
          width: "400px",
        },
        {
          label: "Clientes",
          type: "template",
          template: "customers",
          width: "160px",
        },
        {
          label: "Estímulos",
          type: "template",
          template: "stimulus",
          width: "280px",
        },
        {
          label: "",
          type: "template",
          template: "action",
          align: "right",
          minWidth: "150px",
        },
      ],
      breadcrumbs: [],
    };
    
  },
  computed: {
    idRootNode() {
      return this.data[0].id;
    },
  },
  methods: {
    /**
     * Carrega e abre a dialog análise do nó.
     *
     * @param {Object} node dados do nó
     */
    info(node) {
      this.$emit("info", node);
    },
    /**
     * Carrega e abre a dialog análise do nó.
     *
     * @param {Object} node dados do nó
     */
    add(node) {
      this.$emit("add", node);
    },
    /**
     * Carrega e abre a dialog análise do nó.
     *
     * @param {Object} node dados do nó
     */
    update() {
      this.$emit("updateTree", {
        status: this.treeStatus == "ANALYZABLE" ? "STIMULATE" : "ANALYZABLE",
        unarchive: false,
      });
    },
    /**
     * Edita um nó.
     *
     * @param {Object} node dados do nó
     */
    edit(node) {
      this.$emit("edit", node);
    },
    /**
     * Exclue um nó.
     *
     * @param {Object} node dados do nó
     */
    exclude(node) {
      this.$emit("exclude", node);
    },
    /**
     * Arquiva a árvore.
     *
     * @param {Object} node dados do nó
     */
    disable() {
      this.$emit("updateTree", {
        status: this.treeStatus == "ARCHIVED" ? "ANALYZABLE" : "ARCHIVED",
        unarchive: this.treeStatus == "ARCHIVED",
      });
    },
    getStimulus(stimulus, hot = false) {
      var list = stimulus.filter((s) => s.active).filter((s) => s.hot == hot).sort((a, b) => {
        if ((a.active_at == null && b.active_at == null) && a.order > b.order) return 1;
        if ((a.active_at == null && b.active_at == null) && a.order < b.order) return 1;
        if ((a.active_at == null && b.active_at !== null) && a.order > b.order) return 1;
        if ((a.active_at == null && b.active_at !== null) && a.order < b.order) return 1;
        if ((a.active_at !== null && b.active_at == null) && a.order > b.order) return -1;
        if ((a.active_at !== null && b.active_at == null) && a.order < b.order) return -1;
        if ((a.active_at !== null && b.active_at !== null) && a.order > b.order) return 1;
        if ((a.active_at !== null && b.active_at !== null) && a.order < b.order) return -1;
        return 0;
      });
      return list;
    },
    percentage(customers) {
      let totalCustomers = this.data[0].last_resolution.customers;
      return (customers * 100) / totalCustomers;
    },
    newStimulus(id, located = true) {
      this.$emit("newStimulus", {
        id: id,
        located: located,
      });
    },
    goToTreeApproaches(stimulus) {
      this.$router.push({
        name: "Fluxo de abordagem",
        params: {
          edit: true,
          approach_id: stimulus.approach_flow.id,
        },
      });
    },
    getApproachRules(item) {
      return item.approach_flow.approach_rules.slice().sort((a, b) => {
        if (a.offset < b.offset) return -1;
        if (a.offset > b.offset) return 1;
        return 0;
      });
    },
    getColorApproachRule(type) {
      switch (type) {
        case "SMS":
          return "indigo";
        case "PUSH":
          return "teal";
        case "EMAIL":
          return "orange";
        case "CALL_CELLPHONE":
          return "#007327";
        case "CALL_PHONE":
          return "#004D40";
          case "WHATSAPP":
          return "#535a11";
        default:
          return "primary";
      }
    },
    openDialog() {
      this.dialog = true;
    },
    async getNodeInfo(nodeId) {
      await treeService
        .getNode(nodeId, ["parent"])
        .then((resp) => {
          this.breadcrumbs = utils.mountBreadCrumb(resp.parent);
        });
    },
  },
};
</script>

<style>
.zk-table tr:hover .qj-btn-hide {
  opacity: 1;
}

.zk-table td {
  padding: 0;
}

.qj-btn-hide {
  opacity: 0;
  transition: 0.1s;
}

.qj-scroll-rules {
  width: 800px;
  overflow-x: scroll;
}

.qj-scroll-rules .v-list__tile {
  width: fit-content;
  padding: 0 12px;
}

.leftAlign {
  text-align: left;
}

.container .v-chip .v-chip__content {
  cursor: pointer;
}

.max-list-height {
    max-height: 1000px;
    
}

.v-list--three-line.v-list--dense .qj-offset-list .v-list__tile {
    height: min-content;
}
</style>
